function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Component, register } from 'ovee.js';
import { create as PickerBuilder } from '@easepick/core';
import { KbdPlugin } from '@easepick/kbd-plugin';
import { RangePlugin } from '@easepick/range-plugin';
import { LockPlugin } from '@easepick/lock-plugin';
import gsap from 'gsap';

var _class = (_dec = register('date-picker'), _dec(_class2 = /*#__PURE__*/function (_Component) {
  _inherits(_class2, _Component);

  var _super = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.createInstance();
      this.$on('change', this.mobileMedia, function () {
        var picker = _this.picker,
            cols = _this.cols;
        if (!picker) return;
        picker.cols = cols;
        picker.calendars = cols;
      });
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var _this2 = this;

      var cols = this.cols;
      this.picker = new PickerBuilder({
        element: this.$element,
        grid: cols,
        calendars: cols,
        zIndex: 9999,
        format: 'D MMM YYYY',
        plugins: [KbdPlugin, RangePlugin, LockPlugin],
        autoApply: true,
        RangePlugin: {
          tooltip: false,
          delimiter: ' to ',
          strict: false
        },
        LockPlugin: {
          minDate: new Date()
        },
        KbdPlugin: {
          html: "\n\t\t\t\t\t<style>\n\t\t\t\t\tbutton {\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t}\n\t\t\t\t\tbutton:focus {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\t\t\t\t\t</style>\n\n\t\t\t\t\t<button>&#128197;</button>\n\t\t\t\t"
        },
        css: ["".concat(document.body.dataset.assetsHref, "_/css/easypick.css")]
      });
      var animationProgress = {
        value: 0,
        update: function update() {
          _this2.picker.ui.container.style.setProperty('--animation-progress', animationProgress.value);
        }
      };
      animationProgress.update();
      var hideTimeout;
      var lastStart;
      var lastEnd;
      var immediateHide = false;
      this.picker.on('select', function (e) {
        setTimeout(function () {
          var _lastStart, _lastEnd;

          var _e$detail = e.detail,
              start = _e$detail.start,
              end = _e$detail.end;

          if (start.getTime() === ((_lastStart = lastStart) === null || _lastStart === void 0 ? void 0 : _lastStart.getTime()) && (end === null || end === void 0 ? void 0 : end.getTime()) !== ((_lastEnd = lastEnd) === null || _lastEnd === void 0 ? void 0 : _lastEnd.getTime())) {
            immediateHide = true;

            _this2.picker.hide();

            setTimeout(function () {
              _this2.$element.blur();
            }, 100);
          }

          lastStart = start;
          lastEnd = end;
        });
      });
      this.picker.on('show', function () {
        if (hideTimeout) {
          clearTimeout(hideTimeout);
          hideTimeout = null;
        }

        gsap.killTweensOf(animationProgress);
        gsap.to(animationProgress, {
          value: 1,
          duration: 0.5,
          ease: 'power2.inOut',
          onUpdate: animationProgress.update
        });
      });
      this.picker.on('hide', function () {
        hideTimeout = setTimeout(function () {
          hideTimeout = null;
          gsap.killTweensOf(animationProgress);

          if (immediateHide) {
            immediateHide = false;
            animationProgress.value = 0;
            animationProgress.update();
            return;
          }

          gsap.to(animationProgress, {
            value: 0,
            duration: 0.5,
            ease: 'power2.inOut',
            onUpdate: animationProgress.update
          });
        }, immediateHide ? 0 : 50);
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$picker;

      // eslint-disable-next-line no-unused-expressions
      (_this$picker = this.picker) === null || _this$picker === void 0 ? void 0 : _this$picker.destroy();
    }
  }, {
    key: "mobileMedia",
    get: function get() {
      return window.matchMedia('(max-width: 1023px)');
    }
  }, {
    key: "isMobile",
    get: function get() {
      return !!this.mobileMedia.matches;
    }
  }, {
    key: "cols",
    get: function get() {
      return this.isMobile ? 1 : 2;
    }
  }]);

  return _class2;
}(Component)) || _class2);

export { _class as default };